var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultTableBlockNewIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 174,
    height: 40,
    viewBox: "0 0 174 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 146711",
    style: {
      fill: "#fff",
      stroke: "#e1e1e1",
      strokeDasharray: "2 2"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M0 0h174v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.5.5h173v39H.5z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(4 4)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(60.667 4)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(60.667 4)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(117.333 4)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(117.333 4)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(4 16)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(4 16)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(60.667 16)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(60.667 16)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(117.333 16)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(117.333 16)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(4 28)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(4 28)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(60.667 28)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(60.667 28)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 6642"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29647",
    d: "M0 0h52.667v8H0z",
    style: {
      fill: "#e1e1e1"
    },
    transform: "translate(117.333 28)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 29648",
    d: "M.5.5h51.667v7H.5z",
    style: {
      fill: "none"
    },
    transform: "translate(117.333 28)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTableBlockNewIcon);
export default __webpack_public_path__ + "static/media/default_table_block_new_icon.3f0b039d4b76aba6e55c14eae27ae454.svg";
export { ForwardRef as ReactComponent };